import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import BarbersFilter from './barbersFilterContainer';
import RoleAware from '../../../auth/roleAware';
import { USER_TYPES } from '../../../auth/constants';
import DateFilter from '../../../common/DatePickerV2';
import ExportCsvButton from './ExportCsvButton';

const Filters = ({
  startDate,
  endDate,
  disableDownloadButton,
  headerTextClass,
  csv,
  children,
  disableBarberFilter,
  showUnassigned,
  endingDateMax,
  start,
  end,
  onDateChange,
  submitDate,
  showCsvExport,
  isFetching,
  isDirty,
  presets,
}) => (
  <div className="s-v2">
    <div className="c-report-filters u-mb+">
      <div className="c-report-filters__item">
        <DateFilter range from={start} to={end} endDate={endingDateMax} onChange={onDateChange} presets={presets} />
      </div>
      <RoleAware deny={USER_TYPES.barber} display-if={!disableBarberFilter}>
        <div className="c-report-filters__item u-visible-for-large-and-up">
          <div className={headerTextClass}>Filter by barber</div>
          <BarbersFilter showUnassigned={showUnassigned} />
        </div>
      </RoleAware>
      {children}
      <div>
        <button
          type="button"
          className={classnames('c-btn c-btn--medium c-form-input-group__last')}
          onClick={submitDate}
          disabled={isFetching || !isDirty}
          data-automation-id="button:applyFilter"
        >
          Submit
        </button>
      </div>
      <div className="u-ml" display-if={showCsvExport}>
        <ExportCsvButton
          csv={csv}
          name={`data_${startDate}_to_${endDate}.csv`}
          disabled={isDirty || disableDownloadButton}
        />
      </div>
    </div>
  </div>
);

Filters.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  submitDate: PropTypes.func.isRequired,
  csv: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  headerTextClass: PropTypes.string,
  children: PropTypes.node,
  disableBarberFilter: PropTypes.bool,
  showUnassigned: PropTypes.bool,
  endingDateMax: PropTypes.string.isRequired,
  showCsvExport: PropTypes.bool,
  isFetching: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool,
  presets: PropTypes.string,
  disableDownloadButton: PropTypes.bool,
};

Filters.defaultProps = {
  headerTextClass: 'c-label u-ml--',
  disableBarberFilter: false,
  children: null,
  showUnassigned: false,
  showCsvExport: true,
  isDirty: false,
  disableDownloadButton: false,
  presets: undefined,
};

export default Filters;
